import { Routes, Route } from 'react-router-dom';
import PublicTrackingPage from '../../pages/PublicTrackingPage';

const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<PublicTrackingPage />} />
    </Routes>
  );
};

export default AppRouter;
